import React, { useEffect, useState } from 'react';
import { CheckCircleIcon } from 'lucide-react';
const names = ['María', 'Luciana', 'Valentina', 'Camila', 'Sofía', 'Carolina', 'Florencia', 'Daniela', 'Paula', 'Andrea', 'Martín', 'Juan', 'Diego', 'Nicolás', 'Fernando'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'Bahía Blanca'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showPopup();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showPopup = () => {
    // Select random name and city
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    setCurrentName(randomName);
    setCurrentCity(randomCity);
    setIsVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup between 8-12 seconds
      const nextDelay = Math.floor(Math.random() * (12000 - 8000 + 1) + 8000);
      setTimeout(showPopup, nextDelay);
    }, 4000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-in-bottom-left max-w-xs w-full" data-id="element-214">
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 flex items-start space-x-3" data-id="element-215">
        <div className="flex-shrink-0 mt-1" data-id="element-216">
          <CheckCircleIcon className="w-6 h-6 text-green-500" data-id="element-217" />
        </div>
        <div data-id="element-218">
          <p className="text-sm text-gray-800 font-medium" data-id="element-219">
            🔥 <span className="font-bold" data-id="element-220">{currentName}</span> de{' '}
            <span className="font-bold" data-id="element-221">{currentCity}</span> acaba de comprar
          </p>
          <p className="text-xs text-gray-500 mt-1 font-bold" data-id="element-222">
            RESET CORPORAL 30D
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-223">Hace unos minutos</p>
        </div>
      </div>
    </div>;
}